import { Denomination } from "../interfaces/denomination";
import { fetchWithAuth } from "./fetchWithAuth";

const PROD_APP_URL = process.env.REACT_APP_PROD_APP_URL || "";
const API_URL = process.env.REACT_APP_API_URL || "";
const DEV_API_URL = process.env.REACT_APP_DEV_API_URL || "";
const PROD_API_URL = process.env.REACT_APP_PROD_API_URL || "";

const apiBaseUrl =
  window.location.hostname === "localhost"
    ? API_URL
    : window.location.hostname === new URL(PROD_APP_URL).hostname
      ? PROD_API_URL
      : DEV_API_URL;

export const getDenominations = async (): Promise<Denomination[]> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("User is not authenticated");
  }

  const response = await fetchWithAuth(
    `${apiBaseUrl}/api/denomination/GetDenominations`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};
